<template>
  <main class="assistant-store">
    <!-- 顶部栏 -->
    <header class="store-header">
      <div class="header-left">
        <h1 class="store-title">助手商店</h1>
        <span class="store-subtitle">我的助手</span>
      </div>
      <div class="header-right">

        <div class="search-box">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="#999">
            <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C8.01 14 6 11.99 6 9.5S8.01 5 10.5 5 15 7.01 15 9.5 12.99 14 10.5 14z"/>
          </svg>
          <input
            v-model="searchQuery"
            type="text"
            placeholder="搜索更多技能"
            class="search-input"
          />
        </div>
      </div>
    </header>

    <!-- 分类标签 -->
    <div class="category-tabs">
      <button
        class="cat-tab"
        :class="{ active: activeCategory === 'all' }"
        @click="activeCategory = 'all'"
      >
        全部
      </button>
      <button
        v-for="cat in categories"
        :key="cat.id"
        class="cat-tab"
        :class="{ active: activeCategory === cat.id }"
        @click="activeCategory = cat.id"
      >
        {{ cat.name }}
      </button>
    </div>

    <!-- 技能包标题 -->
    <div class="section-title">
<!--      <span class="title-icon">🏷</span>-->
      <h2>行业助手</h2>
      <span class="title-desc">官方严选优质技能组合</span>
      <span class="title-more">查看更多 ›</span>
    </div>

    <!-- 技能包列表 -->
    <div class="template-grid">
      <div
        v-for="tpl in filteredTemplates"
        :key="tpl.id"
        class="template-card"
      >
        <div class="card-main">
          <div class="card-icon">{{ tpl.icon }}</div>
          <div class="card-info">
            <h3 class="card-title">{{ tpl.name }}</h3>
            <p class="card-desc">{{ tpl.description }}</p>
          </div>
          <button
            class="add-btn-card"
            :class="{ added: isAdded(tpl.id), disabled: !isLoggedIn && !isAdded(tpl.id) }"
            @click="handleAdd(tpl)"
          >
            <template v-if="isAdded(tpl.id)">已添加</template>
            <template v-else-if="!isLoggedIn">🔒 登录后添加</template>
            <template v-else>一键添加</template>
          </button>
        </div>

<!--        <div class="card-meta">-->
<!--          <span class="meta-tag">模型：{{ tpl.llmCode }}</span>-->
<!--          <span class="meta-tag free">免费</span>-->
<!--        </div>-->
      </div>
    </div>

    <!-- 空状态 -->
    <div v-if="filteredTemplates.length === 0" class="empty-state">
      <div class="empty-icon">🔍</div>
      <p>未找到匹配的助手</p>
      <span>试试调整分类或搜索关键词</span>
    </div>
  </main>
</template>

<script>
import {
  assistantSubTypes
} from '../utils/helpers'
import {
  getCategories,
  getAllAssistants,
  getAssistantsByCategory,
  addUserAssistant
} from '../api'

export default {
  name: 'AssistantStore',
  props: {
    addedTemplateIds: {
      type: Array,
      default: () => []
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      categories: [],
      subTypes: assistantSubTypes,
      templates: [],
      activeCategory: 'all',
      activeSubType: '',
      searchQuery: '',
      categoryLoading: false,
      templatesLoading: false,
      categoryError: ''
    }
  },
  mounted() {
    this.loadCategories()
    this.loadTemplates(this.activeCategory)
  },
  watch: {
    activeCategory(newVal) {
      this.loadTemplates(newVal)
    }
  },
  computed: {
    filteredTemplates() {
      let list = this.templates

      if (this.searchQuery.trim()) {
        const q = this.searchQuery.trim().toLowerCase()
        list = list.filter(t =>
          t.name.toLowerCase().includes(q) ||
          t.description.toLowerCase().includes(q) ||
          (t.prompt && t.prompt.toLowerCase().includes(q))
        )
      }

      return list
    }
  },
  methods: {
    async loadCategories() {
      this.categoryLoading = true
      this.categoryError = ''
      try {
        const json = await getCategories()
        if (json.code === '200' && Array.isArray(json.data)) {
          this.categories = json.data
        } else {
          this.categoryError = json.message || '加载分类失败'
        }
      } catch (e) {
        this.categoryError = '网络请求失败，请检查后端服务是否启动'
      } finally {
        this.categoryLoading = false
      }
    },
    async loadTemplates(categoryVal) {
      this.templatesLoading = true
      try {
        const json = categoryVal === 'all'
          ? await getAllAssistants()
          : await getAssistantsByCategory(categoryVal)
        if (json.code === '200' && Array.isArray(json.data)) {
          this.templates = json.data.map(item => this.transformTemplate(item))
        } else {
          this.templates = []
        }
      } catch (e) {
        console.error('加载助手列表失败:', e)
        this.templates = []
      } finally {
        this.templatesLoading = false
      }
    },
    transformTemplate(raw) {
      const descMatch = raw.prompt ? raw.prompt.match(/功能说明[：:]\s*([^\n]+)/) : null
      const description = descMatch ? descMatch[1].trim() : raw.name
      const previewLines = raw.prompt ? raw.prompt.split('\n').filter(l => l.trim()).slice(0, 4) : []
      return {
        ...raw,
        icon: raw.emoji || '🤖',
        description: description,
        promptPreview: previewLines.join('\n') + (previewLines.length >= 4 ? '\n...' : ''),
        skills: []
      }
    },
    isAdded(tplId) {
      return this.addedTemplateIds.includes(tplId)
    },
    handleAdd(tpl) {
      var self = this
      if (self.isAdded(tpl.id)) return
      if (!self.isLoggedIn) {
        self.$emit('require-login')
        return
      }
      var userId = (self.user && self.user.userId) ? self.user.userId : null
      if (!userId) {
        // 缺少 userId，仍然走本地添加
        self.$emit('add-from-template', tpl)
        return
      }
      // 已登录状态：调用新接口 POST /api/user-assistants/user/{userId}
      // body 严格按接口要求只传 name / emoji / prompt
      addUserAssistant(userId, {
        name: tpl.name || '',
        emoji: tpl.icon || tpl.emoji || '',
        prompt: tpl.prompt || tpl.description || ''
      }).then(function (json) {
        // 接口调用成功后再本地把助手加入列表，携带后端返回的 userAssistantId(data.id)
        if (json && (json.code === '200' || json.code === 200 || json.success)) {
          var userAssistantId = null
          if (json.data) {
            if (typeof json.data === 'object') {
              userAssistantId = json.data.id
            } else if (typeof json.data === 'number' || typeof json.data === 'string') {
              userAssistantId = json.data
            }
          }
          self.$emit('add-from-template', tpl, {
            userAssistantId: userAssistantId,
            raw: json.data
          })
        } else {
          // 业务错误但可能后端已保存会话，提示信息已由全局 request 拦截（400 弹窗）
          // 其他错误这里静默提示（避免重复弹窗）
          var msg = (json && json.message) || '添加助手失败'
          if (!msg || !self._isGlobalErrorAlerted(msg)) {
            alert(msg)
          }
        }
      }).catch(function (err) {
        // 400 错误已经由全局 request 层 alert 过了，这里避免重复弹
        if (err && err.status !== 400) {
          alert((err && err.message) || '网络请求失败，请检查后端服务是否启动')
        }
        console.error('添加助手会话失败:', err)
      })
    },
    // 辅助：判断信息是否已经被全局拦截弹过（简单避免重复）
    _isGlobalErrorAlerted(msg) {
      return false
    }
  }
}
</script>

<style scoped>
.assistant-store {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fafafa;
  min-width: 0;
  overflow: hidden;
}

.store-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 28px;
  background: #fff;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.store-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.store-subtitle {
  font-size: 15px;
  color: #666;
  cursor: pointer;
  padding: 6px 14px;
  border-radius: 20px;
  transition: all 0.2s;
}

.store-subtitle:hover {
  background: #f0f0f0;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.record-btn {
  padding: 8px 16px;
  font-size: 13px;
  color: #666;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.record-btn:hover {
  color: #1a9c8e;
  border-color: #1a9c8e;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: #f5f5f5;
  border-radius: 20px;
  width: 280px;
}

.search-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 13px;
  color: #333;
}

.search-input::placeholder {
  color: #999;
}

.category-tabs {
  display: flex;
  gap: 4px;
  padding: 14px 28px;
  background: #fff;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
  overflow-x: auto;
}

.cat-tab {
  padding: 6px 16px;
  font-size: 13px;
  color: #666;
  border-radius: 16px;
  white-space: nowrap;
  transition: all 0.2s;
}

.cat-tab:hover {
  color: #333;
  background: #f5f5f5;
}

.cat-tab.active {
  background: #1a1a1a;
  color: #fff;
}

.subtype-tabs {
  display: flex;
  gap: 8px;
  padding: 12px 28px;
  background: #fff;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

.subtype-tab {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 14px;
  font-size: 13px;
  color: #666;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  transition: all 0.2s;
}

.subtype-tab:hover {
  color: #333;
  border-color: #ccc;
}

.subtype-tab.active {
  color: #1a9c8e;
  border-color: #1a9c8e;
  background: #f0fbf9;
}

.subtype-icon {
  font-size: 14px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px 28px 12px;
  flex-shrink: 0;
}

.title-icon {
  font-size: 18px;
}

.section-title h2 {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.title-desc {
  font-size: 12px;
  color: #999;
  margin-left: 4px;
}

.title-more {
  margin-left: auto;
  font-size: 13px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
}

.title-more:hover {
  color: #1a9c8e;
}

.template-grid {
  flex: 1;
  overflow-y: auto;
  padding: 8px 28px 28px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  align-content: start;
}

.template-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eee;
  padding: 20px;
  transition: all 0.25s ease;
}

.template-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border-color: #e0e0e0;
}

.card-main {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.card-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  flex-shrink: 0;
}

.card-info {
  flex: 1;
  min-width: 0;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 4px;
}

.card-desc {
  font-size: 12px;
  color: #888;
  line-height: 1.5;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.add-btn-card {
  padding: 8px 16px;
  font-size: 13px;
  color: #1a9c8e;
  background: #f0fbf9;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  flex-shrink: 0;
  margin-top: 4px;
}

.add-btn-card:hover {
  background: #1a9c8e;
  color: #fff;
}

.add-btn-card.added {
  background: #f5f5f5;
  color: #999;
  cursor: default;
}

.add-btn-card.disabled {
  background: #f5f5f5;
  color: #999;
  cursor: not-allowed;
  opacity: 0.85;
}

.add-btn-card.disabled:hover {
  background: #eef5f3;
  color: #777;
}

.card-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 14px 0 12px;
}

.meta-tag {
  padding: 3px 8px;
  font-size: 11px;
  color: #666;
  background: #f5f5f5;
  border-radius: 4px;
}

.meta-tag.paid {
  color: #f5a623;
  background: #fff8e6;
}

.meta-tag.free {
  color: #1a9c8e;
  background: #e6f7f5;
}

.meta-download {
  margin-left: auto;
  font-size: 12px;
  color: #999;
}

.card-skills {
  padding-top: 12px;
  border-top: 1px dashed #eee;
}

.skills-title {
  font-size: 12px;
  color: #999;
  margin: 0 0 8px;
}

.skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.skill-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  font-size: 12px;
  color: #555;
  background: #f8f8f8;
  border-radius: 12px;
}

.skill-icon {
  font-size: 13px;
}

.prompt-preview {
  font-size: 12px;
  color: #777;
  line-height: 1.6;
  margin: 0;
  padding: 8px 10px;
  background: #fafafa;
  border-radius: 6px;
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  max-height: 80px;
}

.skill-more {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  font-size: 12px;
  color: #1a9c8e;
  cursor: pointer;
}

.skill-more:hover {
  text-decoration: underline;
}

.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.empty-state p {
  font-size: 15px;
  color: #666;
  margin: 0 0 8px;
}

.empty-state span {
  font-size: 13px;
}

/* ====== 移动端 ≤768px ====== */
@media (max-width: 768px) {
  .assistant-store {
    flex: 1;
    min-height: 0;
  }

  .store-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 14px 14px;
  }

  .header-left {
    gap: 12px;
  }

  .store-title {
    font-size: 18px;
  }

  .store-subtitle {
    font-size: 13px;
    padding: 4px 10px;
  }

  .header-right {
    gap: 8px;
  }

  .record-btn {
    padding: 6px 12px;
    font-size: 12px;
    flex-shrink: 0;
  }

  .search-box {
    width: auto;
    flex: 1;
    padding: 6px 12px;
  }

  .category-tabs {
    padding: 10px 14px;
    gap: 2px;
  }

  .cat-tab {
    padding: 5px 12px;
    font-size: 12px;
  }

  .subtype-tabs {
    padding: 10px 14px;
    gap: 6px;
    overflow-x: auto;
  }

  .subtype-tab {
    padding: 5px 10px;
    font-size: 12px;
    white-space: nowrap;
  }

  .section-title {
    padding: 14px 14px 8px;
    flex-wrap: wrap;
  }

  .section-title h2 {
    font-size: 15px;
  }

  .title-desc {
    display: none;
  }

  .title-more {
    font-size: 12px;
  }

  .template-grid {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 8px 14px 20px;
  }

  .template-card {
    padding: 16px;
  }

  .card-main {
    gap: 10px;
  }

  .card-icon {
    width: 44px;
    height: 44px;
    font-size: 24px;
    border-radius: 10px;
  }

  .card-title {
    font-size: 14px;
  }

  .card-desc {
    font-size: 12px;
  }

  .add-btn-card {
    padding: 6px 12px;
    font-size: 12px;
  }

  .card-meta {
    margin: 10px 0 10px;
  }

  .skills-list {
    gap: 5px;
  }

  .skill-item {
    padding: 3px 8px;
    font-size: 11px;
  }
}

/* ====== 平板 769px~1024px ====== */
@media (min-width: 769px) and (max-width: 1024px) {
  .template-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    padding: 8px 20px 20px;
  }

  .store-header {
    padding: 16px 20px;
  }

  .category-tabs {
    padding: 12px 20px;
  }

  .subtype-tabs {
    padding: 10px 20px;
  }

  .section-title {
    padding: 16px 20px 10px;
  }

  .search-box {
    width: 220px;
  }
}
</style>
